module.exports = __webpack_public_path__ + "static/media/Fall30min.8b3c1097.png";